var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseSheetItem',[_c('v-checkbox',_vm._g(_vm._b({ref:"checkbox",staticClass:"base-checkbox mt-0 pt-0",attrs:{"input-value":_vm.inputValue},scopedSlots:_vm._u([{key:"label",fn:function(){return [_vm._t("label")]},proxy:true}],null,true)},'v-checkbox',_vm.$attrs,false),{
      ..._vm.$listeners,
      change: (ev) => _vm.$emit('change', ev),
    }))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }